module.exports = new __parcel__URL__("error-state-light.84cd22a3.svg").toString();